import VideoSubmissions from './VideoSubmissions';

export default VideoSubmissions;
